import React, { Component } from 'react';
import LinkIcon from '@material-ui/icons/TransitEnterexit';

import '../../../../../chat.css';

/**
 * A message type that shows a link box.
 */
class LinkMessage extends Component {
    render() {
        return(
            <div className={'link-message-container'}>
                <a href={this.props.url} target={'_blank'} rel={'noopener noreferrer'}>
                    <div className={this.props.isSuggestion ? 'link-message-content-container-suggestion' : 'link-message-content-container'}>
                        <span style={{color: this.props.isSuggestion ? ( this.props.hover? this.props.chatConfig.suggestionFontHoverColor : this.props.chatConfig.suggestionFontColor ): (this.props.isUser ? this.props.chatConfig.fontUserColor :this.props.chatConfig.fontBotColor)}}>{this.props.title}</span>
                        <LinkIcon className={'link-icon'}/>
                    </div>
                </a>
            </div>
        );
    }
}

export default LinkMessage;
